export default __webpack_public_path__ + "static/media/rosemontremotelogoblack-01.b6325a5b.png";